export const phoneRegex   = new RegExp('^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$');
export const zipCodeRegex = new RegExp('\\d{5}-?(\\d{4})?');
export const nameRegex    = new RegExp('([\\w]{3,30}\\s*){1,5}');
export const emailRegex   = new RegExp('^[\\w\\d\\+\\._-]+[\\w\\d]+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$');
export const messageRegex = new RegExp('[\\w\\d\\s~!@#$%^&*()`[\\]{};:,\\.\\/<>?|\\-\\+]{6,255}');
